import { createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';
import type { CustomDescendant, Plugin } from '../types';
import * as mention from './mention';
import * as pasteHtml from './paste-html';
import * as maxLength from './max-length';
import * as link from './link';
import * as common from './common';
import { createLinkElement } from './link/utils';

export { createLinkElement };

export const plugins = [common, pasteHtml, maxLength, mention, link] as Plugin[];

export interface CreateCustomEditorOptions {
  children?: CustomDescendant[];
}

export function createCustomEditor({ children }: CreateCustomEditorOptions = {}) {
  const editor = plugins.reduce(
    (editor, { withEditor }) => {
      return withEditor ? withEditor(editor) : editor;
    },
    withReact(withHistory(createEditor()))
  );

  if (children) {
    editor.children = children;
  }

  return editor;
}
